import React, { useEffect, useState } from 'react';
import { useForm, Controller } from 'react-hook-form';
import './SignInForm.scss'
import { useSelector, useDispatch } from 'react-redux';
import { setCountryData as setCountryDataAction } from '../../common/features/user/userActions';
import DialCodePicker, { CountryCodeData } from "../dialCodePicker";
import countrycodedropdown from "../../common/assets/svg/dropdowncountrycode.svg";
import { getOtpRequest } from '../../common/features/auth/AuthActions';
import { useNavigate, useParams } from 'react-router';


type SignInFormData = {
  inputData: string;
  consent: boolean;
};
interface SignInprops {
  otpScreen?: boolean;
  setOtpScreen?: any;
  setdata: any;
  onSubmit: any;
  signInPopupDesktop?: boolean;
  onClose?: any
}
const SignInForm: React.FC<SignInprops> = ({ otpScreen, setOtpScreen, setdata, onSubmit, signInPopupDesktop, onClose }) => {
  const {
    handleSubmit,
    control,
    getValues,
    watch,
    register,
    formState: { errors },
  } = useForm<SignInFormData>({
    mode: 'onSubmit',
    defaultValues: {
      inputData: '',
      consent: false,

    },
  });
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { tableId, merchantType, merchantSlug, menuType } = useParams<any>();

  const isMobile = useSelector((state: any) => state?.navigation?.isMobile)
  const [showDialCodePicker, setShowDialCodePicker] = useState(false);
  const [countrySelected, setCountrySelected] = useState<any>(false);
  const restaurantDetails = useSelector((state: any) => state.restaurant.currentRestaurantDetail);

  // Using country data from user reducer instead of local state
  const countryData = useSelector((state: any) => state.user.countryData);
  const slugFromLocalStorage = localStorage?.getItem("restaurant") && JSON?.parse(
    localStorage?.getItem("restaurant") || ""
  );

  // Function to update country data in the reducer
  const updateCountryData = (data: CountryCodeData) => {
    dispatch(setCountryDataAction(data));
  };
  const getOtpLoading = useSelector(
    (state: any) => state.auth.getOtpLoading
  );

  const getOtpSuccess = useSelector(
    (state: any) => state.auth.getOtpSuccess
  );
  const getOtpFailure = useSelector(
    (state: any) => state.auth.getOtpFailure
  );



  const consentwatch = watch("consent");
  const numberwatch = watch("inputData")


  const handleOnSubmit = (data: SignInFormData) => {
    if (!data.consent) return;    
    setdata(data);
    const mobilePayload = {
      mobilePhone: countryData.code + '-' + data.inputData,
      sendOtpViaEmail: false
    };

    const emailPayload = {
      email: data.inputData,
      sendOtpViaEmail: true
    };
    
    dispatch(getOtpRequest(restaurantDetails?.platformConfiguration?.sendOtpViaEmail ? emailPayload : mobilePayload));
    onSubmit()
  };
  const emailOtp = false;
  const inputError = !!errors?.inputData;


const fieldConfig = restaurantDetails?.platformConfiguration?.sendOtpViaEmail
  ? {
      rules: {
        required: "Email is required",
        pattern: {
          value: /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/,
          message: "Enter a valid email",
        },
      },
      maxLength: 32,
      transform: (v:any) => v, // no transform for email
    }
  : {
      rules: {
        required: "Mobile number is required",
        pattern: {
          value: /^[0-9]{10}$/,
          message: "Mobile number must be exactly 10 digits",
        },
      },
      maxLength: 10,
      transform: (v:any) => v.replace(/\D/g, ""), // strip non-digits
    };





  return (
    <form onSubmit={handleSubmit(handleOnSubmit)} noValidate>
      {/* Mobile Number Field */}
      <div className="form-group-mobile">
        <label className={isMobile ? 'input-label' : 'input-label-D'}>
         {restaurantDetails?.platformConfiguration?.sendOtpViaEmail ? "Email Id" : "Mobile Number" }
          <span className="input-asterisk">*</span>
        </label>

        <div className="signin-popup-screen-Desktop">
          <div
            className={
              isMobile
                ? 'phone-input-container'
                : signInPopupDesktop
                  ? 'phone-input-container-D-Popup'
                  : 'phone-input-container-D'
            }
          >
            {
              !restaurantDetails?.platformConfiguration?.sendOtpViaEmail &&
              <div
                className="countryCodeContainer-new"
                onClick={() => {
                  setShowDialCodePicker(!showDialCodePicker);
                  setCountrySelected(!countrySelected);
                }}
              >
                <img src={countryData.flag} height="14px" width="21px" className="flag" />
                <img src={countrycodedropdown} alt="" className="country-code-dropdown" />
                <span className="countryCode">{countryData.code}</span>
              </div>
            }

            <div className="input-mobile">

              {/* {

                   <Controller
                  name="inputData"
                  control={control}
                  rules={{
                    required: 'Mobile number is required',
                    pattern: {
                      value: /^[0-9]{10}$/,
                      message: 'Mobile number must be exactly 10 digits',
                    },
                  }}
                  render={({ field }) => (
                    <input
                      className="phone-input"
                      type="text"
                      maxLength={10}
                      {...field}
                      onChange={e => {
                        const value = e.target.value.replace(/\D/g, '');
                        field.onChange(value);
                      }}
                    />
                  )}
                />

              } */}

              <Controller
                name="inputData"

                control={control}
                rules={fieldConfig.rules}
                render={({ field }) => (
                  <input
                   className="phone-input-signIn"
                    type="text"
                    style={{width: restaurantDetails?.platformConfiguration?.sendOtpViaEmail ? isMobile ?'300px':"500px" : '100%'}}
                    maxLength={fieldConfig.maxLength}
                    {...field}
                   onChange={(e) =>
          field.onChange(fieldConfig.transform(e.target.value))
        }

                  />
                )}
              />


            </div>

            <DialCodePicker
              showPicker={showDialCodePicker}
              setShowPicker={setShowDialCodePicker}
              setCountrySelected={setCountrySelected}
              setCountryData={updateCountryData}
              inputValue=""
              setIsMobile={true}
              onlyMobile={true}
              top={'100px'}
              width={isMobile ? '70%' : '50%'}
            />
          </div>
          <div>
            {signInPopupDesktop && (
              <button
                type="submit"
                // className={isMobile ? "otp-button" : signInPopupDesktop ? "otp-button-Desktop-D-popup" : "otp-button-Desktop"}

                className={'otp-button-D-popup'}
                disabled={!consentwatch || !numberwatch}
                style={{ opacity: !(!consentwatch || !numberwatch) ? '100%' : '50%' }}
              >
                {getOtpLoading && (!getOtpSuccess || !getOtpFailure) ? 'Loading...' : '  Send OTP'}
              </button>
            )}
          </div>
        </div>
      </div>
      {errors.inputData && <p className="error-message">{errors.inputData.message}</p>}

      {/* Consent Checkbox */}
      <div className="consent-container" style={{ marginTop: inputError ? isMobile?"5px": '-5px' : '22px' }}>
        <div className="checkbox-wrapper">
          <input
            type="checkbox"
            id="consent"
            className="consent-checkbox"
            {...register('consent', {
              required: 'You must provide consent to continue',
            })}
          />
          <label htmlFor="consent" className={isMobile ? 'consent-text' : 'consent-text-D'}>
            {`By checking this box, you agree to receive ${restaurantDetails?.platformConfiguration?.sendOtpViaEmail ? 'Email' : 'SMS messages'} from ${restaurantDetails?.branchName || "Maghil, New York"}. ${restaurantDetails?.platformConfiguration?.sendOtpViaEmail ? 'Email' : 'Message'}
            frequency varies. ${restaurantDetails?.platformConfiguration?.sendOtpViaEmail ? 'Email' : 'Message'} & data rates may apply. You can reply STOP to unsubscribe at
            any time. `}
            <span
              onClick={() => {
                const slug = slugFromLocalStorage?.location ?? merchantSlug
                const type = slugFromLocalStorage?.merchantType ?? merchantType
                onClose()
                navigate(`/${type}/${slug}/account/Policies`)
              }}
              className="clickhere-text"
            >
              Click here
            </span>{' '}
            to view Privacy Policy.
          </label>
        </div>
        {/* {errors.consent && (
          <p className="error-message" >
            {errors.consent.message}
          </p>
        )} */}
      </div>

      {!signInPopupDesktop && (
        <button
          type="submit"
          className={isMobile ? 'otp-button' : 'otp-button-D'}
          disabled={!consentwatch || !numberwatch }
          style={{ opacity: !(!consentwatch || !numberwatch) ? '100%' : '50%' }}
        >
          {getOtpLoading && (!getOtpSuccess || !getOtpFailure) ? 'Loading...' : '  Send OTP'}
        </button>
      )}
    </form>
  );
};

export default SignInForm;